import { render, staticRenderFns } from "./FarmSearch.vue?vue&type=template&id=35a93852&scoped=true"
import script from "./FarmSearch.vue?vue&type=script&lang=js"
export * from "./FarmSearch.vue?vue&type=script&lang=js"
import style0 from "./FarmSearch.vue?vue&type=style&index=0&id=35a93852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a93852",
  null
  
)

export default component.exports